import * as React from 'react';
import {
    GetHandleProps,
    GetTrackProps,
    SliderItem,
} from 'react-compound-slider';
import './slider-component.css';
// *******************************************************
// HANDLE COMPONENT
// *******************************************************
interface IHandleProps {
    domain: number[];
    handle: SliderItem;
    getHandleProps: GetHandleProps;
}

export const Handle: React.FC<IHandleProps> = ({
    domain: [min, max],
    handle: { id, value, percent },
    getHandleProps,
}) => (
    <div
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{
            left: `${percent}%`,
            position: 'absolute',
            marginLeft: '-11px',
            marginTop: '-8px',
            zIndex: 2,
            width: 24,
            height: 24,
            cursor: 'default',
            borderRadius: '50%',
            boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#2ec943',
        }}
        className="fa fa-check"
        {...getHandleProps(id)}
    />
);
export const CancelledHandle: React.FC<IHandleProps> = ({
    domain: [min, max],
    handle: { id, value, percent },
    getHandleProps,
}) => (
    <div
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{
            left: `${percent}%`,
            position: 'absolute',
            marginLeft: '-11px',
            marginTop: '-8px',
            zIndex: 5,
            width: 24,
            height: 24,
            cursor: 'default',
            borderRadius: '50%',
            boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#FF0000',
        }}
        {...getHandleProps(id)}
    />
);

// *******************************************************
// TRACK COMPONENT
// *******************************************************
interface ITrackProps {
    source: SliderItem;
    target: SliderItem;
    getTrackProps: GetTrackProps;
}

export const Track: React.FC<ITrackProps> = ({
    source,
    target,
    getTrackProps,
}) => (
    <div
        style={{
            position: 'absolute',
            height: 10,
            zIndex: 1,
            backgroundColor: '#2ec943',
            borderRadius: 5,
            cursor: 'default',
            left: `${source.percent}%`,
            width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()}
    />
);

export const CancelledTrack: React.FC<ITrackProps> = ({
    source,
    target,
    getTrackProps,
}) => (
    <div
        style={{
            position: 'absolute',
            height: 10,
            zIndex: 1,
            backgroundColor: '#FF0000',
            borderRadius: 5,
            cursor: 'default',
            left: `${source.percent}%`,
            width: `${target.percent - source.percent}%`,
        }}
        {...getTrackProps()}
    />
);

// *******************************************************
// TICK COMPONENT
// *******************************************************
interface ITickProps {
    key: string;
    tick: SliderItem;
    count: number;
    format: (val: number) => React.ReactNode;
    activeTick: number | undefined;
}

export const Tick: React.FC<ITickProps> = ({
    tick,
    count,
    format,
    activeTick,
}) => (
    <div className="statusOption">
        <div
            style={{
                position: 'absolute',
                marginTop: 14,
                width: 1,
                height: 5,
                left: `${tick.percent}%`,
                zIndex: 2,
            }}
        />
        {activeTick === tick.value ? (
            <div
                className="optionTextSelected"
                style={{
                    position: 'absolute',
                    marginTop: 24,
                    fontSize: 'smaller',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    marginLeft: `${-(100 / count) / 2}%`,
                    width: `${100 / count}%`,
                    left: `${tick.percent}%`,
                    zIndex: 1,
                }}
            >
                {format(tick.value)}
            </div>
        ) : (
            <div
                className="optionText"
                style={{
                    position: 'absolute',
                    marginTop: 24,
                    fontSize: 'smaller',
                    textAlign: 'center',
                    marginLeft: `${-(100 / count) / 2}%`,
                    width: `${100 / count}%`,
                    left: `${tick.percent}%`,
                    zIndex: 1,
                }}
            >
                {format(tick.value)}
            </div>
        )}
    </div>
);
